import { getLocale, getLocaleOverride } from '@eventbrite/i18n';
import pickBy from 'lodash/pickBy';
import { CheckoutState } from '../state';

export const getDefaultUserCountry = (state: CheckoutState): string =>
    state.app.defaultUserCountry;

export const getEbDomain = (state: CheckoutState) => state.app?.ebDomain;

export const getActiveFFsFromCore = ({ app }: CheckoutState) => {
    return Object.keys(
        pickBy(app.featureFlags, (value: any) =>
            typeof value === 'object' ? value.isActive : !!value,
        ),
    ).sort();
};

export const getFeatureFlags = ({ app }: CheckoutState) => ({
    featureFlags: app.featureFlags,
});

export const getLocaleProps = ({ app, event }: CheckoutState) => {
    return {
        locales: app.locales,
        defaultLocale:
            getLocaleOverride() ??
            getLocale({
                eventLocale:
                    ('properties' in event && event.properties.locale) || '',
                appLocale: app.locale,
            }),
    };
};

export const isEventbriteTLD = (state: CheckoutState): boolean =>
    state.app.isEventbriteTLD;

export const isTosClickWrapVisible = (state: CheckoutState): boolean =>
    !!state.app?.featureFlags?.enableCheckoutTosClickwrap;

export const getGooglePayEnvironment = (state: CheckoutState) => {
    return state.app.isProd ? 'PRODUCTION' : 'TEST';
};

export const getCurrencyFormat = (state: CheckoutState) =>
    state.app.currencyFormat;
